import { Box, Button, Paper, Typography, useTheme } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import AllInboxIcon from '@mui/icons-material/AllInbox';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import LayersIcon from '@mui/icons-material/Layers';
import CallSplitIcon from '@mui/icons-material/CallSplit';
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import DropdownMenu from './Components/searchOptionComponents/DropdownMenu';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useDispatch, useSelector } from 'react-redux';
import { initialShipmentForm } from '../../actions/formAction';
import ShipmentTable from './Components/Tabel/ShipmetTable';
import Progress from '../../components/Loader/Progress ';
import AnimatedNumbers from "react-animated-numbers";
import { getCount } from '../../actions/getCountAction';
import { getMangeDataAction } from '../../actions/mangeActionV2';

function Shipments() {

    const { t } = useTranslation()
        const location = useLocation();
    
    const theme = useTheme();
    const navigate = useNavigate() ; 
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
      const fetchData = useSelector((state) => state.manageV2.getManage);
        const [anchorEl, setAnchorEl] = useState(null);
        const dataGridPaperRef = useRef(null);
        const countReducer = useSelector((state) => state.fetchCount);
    
    const handlingFetchData = () => {
        dispatch(getMangeDataAction({ mode:"shipment", query: searchParams.toString() }))

        return () => {
            //dispatch(resetData())
        };

    };

    const openAddShipmentMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const closeAddShipmentMenu = () => {
        setAnchorEl(null);
    };

    const handleAddShipmentMode = (mode) => {
        closeAddShipmentMenu();
        navigate(`/addShipment?shipmentMode=${encodeURIComponent(mode)}`);
    };
    useEffect(() => {
        dispatch(initialShipmentForm())
                dispatch(getCount({ mode: "shipment" }))

    }, [dispatch]);


     const handleCardClick = (name, id) => {
        // Get the current query parameters
        const searchParams = new URLSearchParams(location.search);
        const pageSize = searchParams.get('PageSize') || null;

        // Set the 'name' parameter to the given id
        if (name === 'Status') {
            searchParams.set('Status', id);
            if (pageSize === null) {
                navigate(`/shipments?Status=${id}&PageSize=5`)
            } else {
                navigate(`/shipments?Status=${id}`)
            }

        } else {
            if (pageSize === null) {
                navigate(`/shipments?SearchOption=${id}&PageSize=5`)
            } else {
                navigate(`/shipments?SearchOption=${id}`)
            }

        }


        if (dataGridPaperRef.current) {
            dataGridPaperRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
        }

    };


    const searchQuery = searchParams.toString();

    useEffect(() => {
        dispatch(getMangeDataAction({ mode: "shipment", query: searchQuery }))
    }, [dispatch, searchQuery])
        

return (
    <Box sx={{ width: '100%', bgcolor: '#F7F8FA', minHeight: '100vh', p: { xs: 0, md: 2 } }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 2, mb: 3, mt: { xs: 2, md: 0 } }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <AllInboxIcon sx={{ color: '#0B3C5D', fontSize: 36 }} />
                <Typography variant="h4" sx={{ color: '#0B3C5D', fontWeight: 800, letterSpacing: 1 }}>
                    {t('Shipments')}
                </Typography>
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, alignItems: 'end', justifyContent: 'end' }}>
                <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    sx={{
                        borderRadius: 2,
                        fontWeight: 700,
                        position: 'relative',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                    startIcon={
                        <AddCircleOutlineIcon
                            sx={{
                                color: theme.palette.secondary.main,
                                fontSize: 24,
                                bgcolor: theme.palette.background.paper,
                                borderRadius: '50%'
                            }}
                        />
                    }
                    endIcon={<KeyboardArrowDownIcon />}
                    onClick={openAddShipmentMenu}
                >
                    {t('New Shipment')}
                </Button>
                <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={closeAddShipmentMenu}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                    PaperProps={{
                        elevation: 10,
                        sx: {
                            borderRadius: 3,
                            minWidth: 300,
                            py: 1,
                            bgcolor: theme.palette.background.paper,
                            boxShadow: '0 18px 48px rgba(11, 60, 93, 0.18)',
                        },
                    }}
                >
                    <Box sx={{ px: 3, py: 2, borderBottom: `1px solid ${theme.palette.divider}` }}>
                        <Typography sx={{ fontWeight: 700, fontSize: 15, mb: 0.5 }}>
                            {t('Choose Shipment Type')}
                        </Typography>
                        <Typography variant="caption" sx={{ color: theme.palette.text.secondary, lineHeight: 1.4 }}>
                            {t('Select the shipment mode to start adding')}
                        </Typography>
                    </Box>
                    <MenuItem
                        onClick={() => handleAddShipmentMode('FCL')}
                        sx={{
                            px: 3,
                            py: 1.5,
                            gap: 2,
                            borderRadius: 3,
                            mb: 1,
                            display: 'flex',
                            alignItems: 'center',
                            bgcolor: '#E8F1FF',
                            '&:hover': {
                                bgcolor: '#D3E6FF',
                            },
                        }}
                    >
                        <Box sx={{ width: 40, height: 40, borderRadius: '50%', bgcolor: '#C9DEFF', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <LocalShippingIcon sx={{ color: '#1D4DB5', fontSize: 20 }} />
                        </Box>
                        <Box sx={{ flex: 1 }}>
                            <Typography sx={{ fontWeight: 700, fontSize: 14 }}>
                                {t('Full Container Load')}
                            </Typography>
                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary }}>
                                FCL
                            </Typography>
                        </Box>
                    </MenuItem>
                    <MenuItem
                        onClick={() => handleAddShipmentMode('LCL')}
                        sx={{
                            px: 3,
                            py: 1.5,
                            gap: 2,
                            borderRadius: 3,
                            mb: 1,
                            display: 'flex',
                            alignItems: 'center',
                            bgcolor: '#FFF4E6',
                            '&:hover': {
                                bgcolor: '#FFE7CC',
                            },
                        }}
                    >
                        <Box sx={{ width: 40, height: 40, borderRadius: '50%', bgcolor: '#F6D49F', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <LayersIcon sx={{ color: '#B56B00', fontSize: 20 }} />
                        </Box>
                        <Box sx={{ flex: 1 }}>
                            <Typography sx={{ fontWeight: 700, fontSize: 14 }}>
                                {t('Less than Container Load')}
                            </Typography>
                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary }}>
                                LCL
                            </Typography>
                        </Box>
                    </MenuItem>
                    <MenuItem
                        onClick={() => handleAddShipmentMode('SPL')}
                        sx={{
                            px: 3,
                            py: 1.5,
                            gap: 2,
                            borderRadius: 3,
                            display: 'flex',
                            alignItems: 'center',
                            bgcolor: '#EAF9ED',
                            '&:hover': {
                                bgcolor: '#D7F2D4',
                            },
                        }}
                    >
                        <Box sx={{ width: 40, height: 40, borderRadius: '50%', bgcolor: '#B8E6B0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <CallSplitIcon sx={{ color: '#207A22', fontSize: 20 }} />
                        </Box>
                        <Box sx={{ flex: 1 }}>
                            <Typography sx={{ fontWeight: 700, fontSize: 14 }}>
                                {t('Split container loaded')}
                            </Typography>
                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary }}>
                                SPL
                            </Typography>
                        </Box>
                    </MenuItem>
                </Menu>
            </Box>
        </Box>

         {/* إحصائيات الحجز */}
                    <Paper
                        sx={{
                            p: { xs: 1, md: 3 },
                            minHeight: 180,
                            flexGrow: 1,
                            background: 'linear-gradient(135deg, #f8fafc 0%, #e9ecef 100%)',
                            borderRadius: 4,
                            boxShadow: '0 8px 32px 0 rgba(11, 60, 93, 0.10)',
                            border: '1px solid #e9ecef',
                            mb: 3,
                        }}
                    >
                        {countReducer.loading === 'pending' || countReducer.loading === 'idle' ? <Progress /> :
                            <Box>
                                <Box sx={{ display: 'flex', mt: 2, justifyContent: 'center', flexWrap: 'wrap', gap: 3 }}>
                                    {countReducer.Object?.map((item, index) => {

                                        if (item?.name?.toUpperCase() === 'Total'.toUpperCase()) {

                                            return (<></>)
                                        }
                                        // ألوان الدائرة والخط حسب الفهرس
                                        const circleColor = ['#0B3C5D', '#D9B310', '#1A5F8C', '#A98A0C', '#F3D351', '#051E30'][index % 6];
                                        const textColor = (index % 6 === 0 || index % 6 === 2 || index % 6 === 5) ? '#fff' : '#0B3C5D';
                                        return (
                                            <Box
                                                key={index}
                                                sx={{
                                                    width: 130,
                                                    height: 160,
                                                    borderRadius: 4,
                                                    background: '#fff',
                                                    boxShadow: '0 2px 8px 0 rgba(11, 60, 93, 0.08)',
                                                    border: '1px solid #e9ecef',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                    justifyContent: 'flex-start',
                                                    position: 'relative',
                                                    overflow: 'hidden',
                                                    transition: 'transform 0.18s, box-shadow 0.18s',
                                                    '&:hover': {
                                                        transform: 'scale(1.06)',
                                                        boxShadow: '0 8px 24px 0 rgba(11, 60, 93, 0.16)',
                                                    },
                                                    cursor: 'pointer',
                                                    p: 0,
                                                }}
                                                onClick={() => handleCardClick(item.type, item.id)}
                                            >
                                                {/* دائرة رقم الإحصائية */}
                                                <Box sx={{
                                                    width: 68,
                                                    height: 68,
                                                    borderRadius: '50%',
                                                    background: `linear-gradient(135deg, ${circleColor} 60%, #fff 100%)`,
                                                    boxShadow: '0 2px 8px 0 rgba(11, 60, 93, 0.10)',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    mt: 2,
                                                    mb: 1.5,
                                                }}>
                                                    <Typography variant='h4' sx={{ color: textColor, fontWeight: 800, fontSize: 30, textShadow: textColor === '#fff' ? '0 1px 4px #0B3C5D55' : 'none' }}>
                                                        <AnimatedNumbers
                                                            animateToNumber={item.count}
                                                            fontStyle={{ fontSize: 30 }}
                                                            configs={(number, index) => {
                                                                return { mass: 1, tension: 230 * (index + 1), friction: 50 };
                                                            }}
                                                        />
                                                    </Typography>
                                                </Box>
                                                {/* اسم الإحصائية */}
                                                <Typography sx={{ color: '#0B3C5D', fontWeight: 700, fontSize: 16, textAlign: 'center', px: 1, mb: 1 }}>{item.name}</Typography>
                                            </Box>
                                        );
                                    })}
                                </Box>
                            </Box>
                        }
                    </Paper>

        <Paper
                sx={{
                    p: { xs: 1, md: 3 },
                    minHeight: 200,
                    flexGrow: 1,
                    mt: 3,
                    background: '#fff',
                    borderRadius: 4,
                    boxShadow: '0 8px 32px 0 rgba(11, 60, 93, 0.10)',
                    border: '1px solid #e9ecef',
                }}
            >

                <Box sx={{ mb: 2, width: '100%' }}>
                    <DropdownMenu onFetchData={handlingFetchData} />

                </Box>

               {fetchData.loading === 'pending' ? <Progress Msg='Loading ...' /> :

                <ShipmentTable handlingFetchData={handlingFetchData} />
                }



            </Paper>
    </Box>
);
}

export default Shipments